import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '../_services/global.service';

@Pipe({
  name: 'currencyDisplay',
  pure: true
})
export class CurrencyDisplayPipe implements PipeTransform {
  transform(value: any, fractionDigits: string = '1.2-2'): string {
    const numericValue = this.toNumericValue(value);
    const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

    const [intPart, fracPart = '2-2'] = String(fractionDigits).split('.');
    const [minFracRaw, maxFracRaw] = fracPart.split('-');
    const minimumFractionDigits = Number.isFinite(Number(minFracRaw)) ? Number(minFracRaw) : 2;
    const maximumFractionDigits = Number.isFinite(Number(maxFracRaw)) ? Number(maxFracRaw) : minimumFractionDigits;

    const currencyCode = GlobalService.getCurrencyCode();
    const locale = currencyCode === 'PKR' ? 'en-PK' : 'en-US';

    const formattedNumber = safeValue.toLocaleString(locale, {
      minimumFractionDigits,
      maximumFractionDigits
    });

    if (currencyCode === 'PKR') {
      return `${GlobalService.getCurrencySymbol()} ${formattedNumber}`;
    }

    return `$${formattedNumber}`;
  }

  private toNumericValue(value: any): number {
    if (typeof value === 'number') {
      return value;
    }

    if (value === null || value === undefined) {
      return 0;
    }

    const raw = String(value).trim();
    if (!raw) {
      return 0;
    }

    // Supports values already formatted by Angular currency pipe,
    // e.g. "Rs. 1,234.50", "$1,234.50", "PKR 1,234.50".
    const normalized = raw.replace(/[^0-9.-]/g, '');
    if (!normalized || normalized === '-' || normalized === '.') {
      return 0;
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }
}
